module.exports = __webpack_public_path__ + "static/z_tall_wheaties-8195cddbd1591a9f9caef78fea10dead.jpg";